// extracted by mini-css-extract-plugin
export const ribbon = "Ribbon-module--ribbon--3Osz7";